import deviceApi from '@/services/device.service'
import organizationApi from '@/services/organization.service'
import type { RentalModel } from '@/types/models/RentalModel'
import { EDeviceMutations } from '@rfc/rfc-components-library/store'
import type { PaginationType } from '@rfc/rfc-components-library/types'
import type { Commit } from 'vuex'
import { EDeviceActions } from './deviceStoreTypes'

const actions = {
    async [EDeviceActions.GET_AVAILABLE_DEVICES](
        { commit }: { commit: Commit },
        { start_at, end_at }: { start_at: Date; end_at: Date }
    ) {
        commit(EDeviceMutations.SET_LOADING, true)
        return await deviceApi
            .getAvailableDevices({ start_at, end_at, page: -1 })
            .then(res => res.data ?? res)
            .finally(() => {
                commit(EDeviceMutations.SET_LOADING, false)
            })
    },

    async [EDeviceActions.GET_DEVICE_RENTALS_HISTORY](
        { commit }: { commit: Commit },
        {
            deviceId,
            organizationId,
            ...params
        }: {
            deviceId: number
            organizationId: number
        } & PaginationType &
            RentalModel
    ) {
        commit(EDeviceMutations.SET_LOADING, true)
        return await organizationApi
            .getDeviceRentalsHistory(organizationId, deviceId, {
                start_at: params.start_at,
                end_at: params.end_at,
                page: -1
            })
            .then(res => res.data ?? res)
            .finally(() => {
                commit(EDeviceMutations.SET_LOADING, false)
            })
    }
}

export default {
    namespaced: true,
    actions
}
